"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Slice = void 0;
var create_entity_1 = require("../../utils/create-entity");
var slice_details_layout_1 = require("../../components/entities/slice-details-layout");
var graphql_1 = require("../../utils/graphql");
var utils_1 = require("../../utils");
var gql = String.raw;
exports.Slice = {
  name: 'Slice',
  autoRoutes: ['create', 'update', 'details'],
  table: {
    fieldNames: ["name", "layout", "title", "content"]
  },
  useConnections: true,
  update: {
    valueKeys: function (fieldName) {
      if (fieldName === 'videos') {
        return ['id', 'url', 'text'];
      }
      return ['url', 'id', 'text'];
    },
    queryFields: "color { value } backgroundColor { value }"
  },
  components: {
    details: slice_details_layout_1.SliceDetailsLayout
  },
  details: {
    queryFields: (0, graphql_1.graphql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      title\n      subtitle\n      pretitle\n      layout { ...EntityValueFields }\n      content { ...ContentNodeFields }\n      intro { ...ContentNodeFields }\n      outro { ...ContentNodeFields }\n\n      videos { ...EntityValueFields }\n\n      backgroundImages { ...EntityValueFields }\n      images { ...EntityValueFields }\n      color { ...EntityValueFields value darkValue }\n      pages { ...EntityValueFields }\n      people { ...EntityValueFields path }\n      links { ...EntityValueFields }\n      organisations { ...EntityValueFields }\n      feedEntries { ...EntityValueFields }\n      backgroundColor { ...EntityValueFields value darkValue }\n      files { ...FileAssetValueFields }\n      parentPage { ...EntityValueFields }\n\n      blocks {\n        id name slug title subtitle\n        content { id text }\n        layout { ...EntityValueFields }\n        links { ...EntityValueFields }\n        page { ...EntityValueFields }\n        image { ...EntityValueFields }\n        color { ...EntityValueFields value darkValue }\n      }\n    "], ["\n      title\n      subtitle\n      pretitle\n      layout { ...EntityValueFields }\n      content { ...ContentNodeFields }\n      intro { ...ContentNodeFields }\n      outro { ...ContentNodeFields }\n\n      videos { ...EntityValueFields }\n\n      backgroundImages { ...EntityValueFields }\n      images { ...EntityValueFields }\n      color { ...EntityValueFields value darkValue }\n      pages { ...EntityValueFields }\n      people { ...EntityValueFields path }\n      links { ...EntityValueFields }\n      organisations { ...EntityValueFields }\n      feedEntries { ...EntityValueFields }\n      backgroundColor { ...EntityValueFields value darkValue }\n      files { ...FileAssetValueFields }\n      parentPage { ...EntityValueFields }\n\n      blocks {\n        id name slug title subtitle\n        content { id text }\n        layout { ...EntityValueFields }\n        links { ...EntityValueFields }\n        page { ...EntityValueFields }\n        image { ...EntityValueFields }\n        color { ...EntityValueFields value darkValue }\n      }\n    "])))
  },
  form: {
    modal: {
      fill: true
    },
    fieldSets: [{
      name: 'overview'
    }, {
      name: 'titles'
    }, {
      name: 'content'
    }, {
      name: 'blocks'
    }, {
      name: 'library'
    }, {
      name: 'colors'
    }, {
      name: 'taxonomies',
      label: process.env.TAXONOMIES_LABEL || 'Challenges & Goals'
    }, {
      name: 'community'
    }, {
      name: 'data'
    }, {
      name: 'places'
    }, {
      name: 'participate'
    }, {
      name: 'contact'
    }, {
      name: 'expertise'
    }, {
      name: 'placeholders'
    }, {
      name: 'options'
    }, {
      name: 'management'
    }],
    fields: __assign(__assign({}, create_entity_1.entityStandardFormFields), {
      name: {
        type: 'text',
        required: true,
        description: 'Please provide a name for this {{SLICE}}. This is not generally displayed on a website, it is intended to succinctly describe the purpose of this {{SLICE}}.',
        fieldSet: 'overview'
      },
      layout: {
        type: 'linked',
        entityTypeName: 'SliceLayout',
        label: 'Layout',
        description: 'Select an appropriate layout for this {{SLICE}}. Layouts allow the same {{SLICE}} to be presented with a different visual design.'
      },
      label: {
        type: 'text',
        description: 'Enter a label for this {{SLICE}}. This is used when the associated {{SLICE_LAYOUT}} needs to show a small label describing this slice.',
        recommended: false
      },
      connectedEntities: {
        type: 'linkedMultiple',
        label: 'Connected Entity Fields',
        entityTypeName: 'SliceField',
        description: 'When using a Connections layout, which connected entity fields do you want to show in the listing? i.e. When a field is selected here, the slice will render all items from that field.',
        isVisible: function () {
          return (0, utils_1.currentUserCanAdmin)();
        }
      },
      entityLayout: {
        type: 'linked',
        label: 'Connected Entity Layout',
        isVisible: function () {
          return (0, utils_1.currentUserCanAdmin)();
        },
        description: 'When using a Connections layout, how do you want to display the connected items?',
        entityTypeName: 'EntityLayout'
      },
      entityTypes: {
        type: 'linkedMultiple',
        label: 'Entity Types',
        entityTypeName: 'EntityType',
        description: 'When using a layout supporting a set of entity types, such as Entity Type Tabs, which types do you want to show?',
        isVisible: function () {
          return (0, utils_1.currentUserCanAdmin)();
        }
      },
      headerFontType: {
        type: 'linked',
        label: 'Header Font Type',
        entityTypeName: 'FontType',
        description: 'Which {{FONT_TYPE}} would you like to use to render <b>headers</b> within this {{SLICE}}. If not selected, this will default to sans-serif fonts.'
      },
      bodyFontType: {
        type: 'linked',
        label: 'Body Font Type',
        entityTypeName: 'FontType',
        description: 'Which {{FONT_TYPE}} would you like to use to render <b>body copy</b> within this {{SLICE}}. If not selected, this will default to sans-serif fonts.'
      },
      title: {
        type: 'text',
        fieldSet: 'titles'
      },
      subtitle: {
        type: 'text',
        fieldSet: 'titles'
      },
      pretitle: {
        type: 'text',
        fieldSet: 'titles'
      },
      titleRich: {
        type: 'longText',
        fieldSet: 'titles',
        label: 'Title (Rich)',
        description: 'Provide a rich version of the title if needed. This can be useful, for example, when needing art-directed text, such as forced line-breaks or emphasis of certain words.'
      },
      subtitleRich: {
        type: 'longText',
        fieldSet: 'titles',
        label: 'Subtitle (Rich)',
        description: 'Provide a rich version of the subtitle if needed. This can be useful, for example, when needing art-directed text, such as forced line-breaks or emphasis of certain words.'
      },
      pretitleRich: {
        type: 'longText',
        fieldSet: 'titles',
        label: 'Pretitle (Rich)',
        description: 'Provide a rich version of the pre-title if needed. This can be useful, for example, when needing art-directed text, such as forced line-breaks or emphasis of certain words.'
      },
      ownEmptyTout: {
        type: 'longText',
        fieldSet: 'management',
        label: 'Empty Tout (Own)',
        isVisible: function () {
          return (0, utils_1.currentUserCanAdmin)();
        },
        description: 'Enter a message to display as a call to action for a user to provide information, where no data has yet been provided. This is displayed when data in this {{SLICE}} is being managed, and contains the user\'s "own" data, such as when they are editing their own profile.'
      },
      ownIncompleteTout: {
        type: 'longText',
        fieldSet: 'management',
        label: 'Incomplete Tout (Own)',
        isVisible: function () {
          return (0, utils_1.currentUserCanAdmin)();
        },
        description: 'Enter a message to display as a call to action for a user to provide <b>extra</b> information. This is displayed when data in this {{SLICE}} contains the user\'s "own" data, such as when they are editing their own profile.'
      },
      emptyTout: {
        type: 'longText',
        fieldSet: 'management',
        label: 'Empty Tout',
        isVisible: function () {
          return (0, utils_1.currentUserCanAdmin)();
        },
        description: 'Enter a message to display as a call to action for a user to provide information for this {{SLICE}}. This will be displayed in a management context (editing screen) when there is <b>no information yet provided</b>.'
      },
      incompleteTout: {
        type: 'longText',
        fieldSet: 'management',
        label: 'Incomplete Tout',
        isVisible: function () {
          return (0, utils_1.currentUserCanAdmin)();
        },
        description: 'Enter a message to display as a call to action for a user to provide extra information for this {{SLICE}}, when in a management context (editing screen).'
      },
      objectives: {
        type: 'linkedMultiple',
        entityTypeName: 'Objective',
        fieldSet: 'taxonomies'
      },
      intro: {
        type: 'longText',
        fieldSet: 'content',
        height: '60px',
        recommended: false
      },
      content: {
        type: 'longText',
        fieldSet: 'content',
        height: '150px'
      },
      outro: {
        type: 'longText',
        fieldSet: 'content',
        height: '60px',
        recommended: false
      },
      pages: {
        type: 'linkedMultiple',
        entityTypeName: 'Page',
        recommended: false,
        fieldSet: 'Content'
      },
      icons: {
        type: 'linkedMultiple',
        entityTypeName: 'Icon',
        fieldSet: 'library'
      },
      disabled: {
        type: 'boolean',
        recommended: false
      },
      themeMode: {
        type: 'linked',
        description: 'Is there a specific {{THEME_MODE}} this {{SLICE}} should be displayed in? If not specified, this will just be the default Light {{THEME_MODE}}. Note: Dark mode is appropriate when you want things to appear "inverted", i.e. a dark background and white text and links.',
        entityTypeName: 'ThemeMode',
        recommended: false,
        fieldSet: 'overview'
      },
      viewTarget: {
        type: 'linked',
        entityTypeName: 'View',
        label: 'View Target',
        description: "What view does this {{SLICE}} target, when the {{SLICE}} represents a sidebar menu item? Note: if this link is in an explorer sidebar, targeting a view will render an entirely new view in both the main and aside section, which will navigate away from the menu with the sidebar. Thus, you may want to setup a target sub view below instead, which will replace the main part of the explorer view."
      },
      subviewTarget: {
        type: 'linked',
        entityTypeName: 'View',
        label: 'Sub-view Target',
        description: "What sub-view does this {{SLICE}} target, when the {{SLICE}} represents a sidebar menu item? Note: in an explorer view, this will generally mean the targeted view will be rendered in the main column."
      },
      backgroundColor: {
        type: 'linked',
        recommended: false,
        label: 'Background Color',
        entityTypeName: 'Color',
        fieldSet: 'colors'
      },
      color: {
        type: 'linked',
        recommended: false,
        entityTypeName: 'Color',
        fieldSet: 'colors'
      },
      blocks: {
        type: 'linkedTable',
        entityTypeName: 'Block',
        fieldSet: 'blocks'
      },
      links: {
        type: 'linkedMultiple',
        entityTypeName: 'Link',
        fieldSet: 'library'
      },
      images: {
        type: 'linkedMultiple',
        label: "Images",
        entityTypeName: 'ImageAsset',
        fieldSet: 'library'
      },
      backgroundImages: {
        type: 'linkedMultiple',
        label: "Background Images",
        entityTypeName: 'ImageAsset',
        fieldSet: 'library'
      },
      people: {
        type: 'linkedMultiple',
        entityTypeName: 'Person',
        fieldSet: 'community'
      },
      organisations: {
        type: 'linkedMultiple',
        entityTypeName: 'Organisation',
        fieldSet: 'community'
      },
      posts: {
        type: 'linkedMultiple',
        entityTypeName: 'Post',
        fieldSet: 'library'
      },
      options: {
        type: 'json',
        description: "Add extra options in JSON format. Note: this is intended as a hook for developers to be able to change advanced properties not available in the standard content fields.",
        fieldSet: 'admin'
      },
      videos: {
        type: 'linkedMultiple',
        entityTypeName: 'Video',
        fieldSet: 'library'
      },
      feedEntries: {
        type: 'linkedMultiple',
        entityTypeName: 'FeedEntry',
        fieldSet: 'library'
      },
      files: {
        type: 'linkedMultiple',
        entityTypeName: 'FileAsset',
        fieldSet: 'library'
      },
      citations: {
        type: 'linkedMultiple',
        entityTypeName: 'Citation',
        fieldSet: 'library'
      },
      locations: {
        type: 'linkedMultiple',
        entityTypeName: 'Location',
        fieldSet: 'places'
      },
      economies: {
        type: 'linkedMultiple',
        entityTypeName: 'Economy',
        fieldSet: 'places'
      },
      globalRegions: {
        type: 'linkedMultiple',
        entityTypeName: 'GlobalRegion',
        fieldSet: 'places'
      },
      states: {
        type: 'linkedMultiple',
        entityTypeName: 'State',
        fieldSet: 'places'
      },
      challengeExpertise: {
        type: 'linkedTable',
        isMulti: true,
        label: "Challenge Expertise",
        entityTypeName: 'ChallengeExpertise',
        fieldSet: 'expertise'
      },
      keyIssueExpertise: {
        type: 'linkedTable',
        isMulti: true,
        label: "Key Issue Expertise",
        entityTypeName: 'KeyIssueExpertise',
        fieldSet: 'expertise'
      },
      trendExpertise: {
        type: 'linkedTable',
        isMulti: true,
        label: "Trend Expertise",
        entityTypeName: 'TrendExpertise',
        fieldSet: 'expertise'
      },
      topicExpertise: {
        type: 'linkedTable',
        isMulti: true,
        label: "Topic Expertise",
        entityTypeName: 'TopicExpertise',
        fieldSet: 'expertise'
      },
      subTopicExpertise: {
        type: 'linkedTable',
        isMulti: true,
        label: "Sub Topic Expertise",
        entityTypeName: 'SubTopicExpertise',
        fieldSet: 'expertise'
      },
      sdgExpertise: {
        type: 'linkedTable',
        isMulti: true,
        label: "SDG Expertise",
        entityTypeName: 'SdgExpertise',
        fieldSet: 'expertise'
      },
      positions: {
        type: 'linkedTable',
        label: "{{ORGANISATIONS}}",
        entityTypeName: 'OrganisationPosition',
        fieldSet: 'roles',
        description: 'Does this {{PERSON}} hold any {{POSITIONS}} in one or more {{ORGANISATIONS}}?'
      },
      challenges: {
        type: 'linkedMultiple',
        entityTypeName: 'Challenge',
        fieldSet: 'taxonomies'
      },
      keyIssues: {
        type: 'linkedMultiple',
        entityTypeName: 'KeyIssue',
        fieldSet: 'taxonomies'
      },
      trends: {
        type: 'linkedMultiple',
        entityTypeName: 'Trend',
        fieldSet: 'taxonomies'
      },
      topics: {
        type: 'linkedMultiple',
        entityTypeName: 'Topic',
        fieldSet: 'taxonomies'
      },
      subTopics: {
        type: 'linkedMultiple',
        entityTypeName: 'SubTopic',
        fieldSet: 'taxonomies'
      },
      indicators: {
        type: 'linkedMultiple',
        entityTypeName: 'Indicator',
        fieldSet: 'data'
      },
      indicatorGroups: {
        type: 'linkedMultiple',
        entityTypeName: 'IndicatorGroup',
        fieldSet: 'data'
      },
      email: {
        type: 'text',
        fieldSet: 'contact'
      },
      websiteUrl: {
        type: 'url',
        maxWidth: '800px',
        fieldSet: 'contact'
      },
      phone: {
        type: 'text',
        maxWidth: '200px',
        fieldSet: 'contact',
        description: 'Enter the phone number for this {{PERSON}} (mobile preferred) in international format e.g. +61400000000.'
      },
      facebook: {
        type: 'text',
        maxWidth: '550px',
        fieldSet: 'contact',
        placeholder: 'https://facebook.com/name',
        description: 'What is the public URL of the Facebook profile?'
      },
      twitter: {
        type: 'text',
        label: "X",
        maxWidth: '550px',
        fieldSet: 'contact',
        placeholder: 'https://x.com/handle',
        description: 'What is the public URL of the X (formerly Twitter) profile?'
      },
      threads: {
        type: 'text',
        maxWidth: '550px',
        fieldSet: 'contact',
        placeholder: 'https://www.threads.net/@handle',
        description: 'What is the URL of the Threads profile?'
      },
      linkedin: {
        type: 'text',
        maxWidth: '550px',
        fieldSet: 'contact',
        label: 'LinkedIn',
        placeholder: 'https://www.linkedin.com/in/first.last',
        description: 'What is the public URL of the LinkedIn profile?'
      },
      sdgs: {
        type: 'linkedMultiple',
        entityTypeName: 'Sdg',
        fieldSet: 'taxonomies'
      },
      events: {
        type: 'linkedMultiple',
        entityTypeName: 'Event',
        fieldSet: 'participate'
      },
      sessions: {
        type: 'linkedMultiple',
        entityTypeName: 'Session',
        fieldSet: 'participate'
      },
      venues: {
        type: 'linkedMultiple',
        entityTypeName: 'Venue',
        fieldSet: 'participate'
      },
      rooms: {
        type: 'linkedMultiple',
        entityTypeName: 'Room',
        fieldSet: 'participate'
      },
      teams: {
        type: 'linkedMultiple',
        entityTypeName: 'Team',
        fieldSet: 'participate'
      },
      workstreams: {
        type: 'linkedMultiple',
        entityTypeName: 'Workstream',
        fieldSet: 'participate'
      },
      tasks: {
        type: 'linkedMultiple',
        entityTypeName: 'Task',
        fieldSet: 'participate'
      },
      horizons: {
        type: 'linkedMultiple',
        entityTypeName: 'Horizon',
        fieldSet: 'taxonomies'
      },
      impactResults: {
        type: 'linkedMultiple',
        entityTypeName: 'ImpactResult',
        fieldSet: 'taxonomies'
      },
      documents: {
        type: 'linkedMultiple',
        entityTypeName: 'Document',
        fieldSet: 'content'
      },
      products: {
        type: 'linkedMultiple',
        entityTypeName: 'Product',
        fieldSet: 'library'
      }
    })
  }
};
var templateObject_1;